var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlacement = function SvgPlacement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 14,
    viewBox: "0 0 11 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#D7B452",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M9 2.002 1.998 2Q2 2 2 11.998L9.002 12zm-8 0A1 1 0 0 1 1.998 1h7.004c.551 0 .998.456.998 1.002v9.996A1 1 0 0 1 9.002 13H1.998C1.447 13 1 12.544 1 11.998z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3h1v2H3zM7 3h1v2H7zM7 6h1v2H7zM7 9h1v2H7zM5 3h1v2H5zM3 6h1v2H3zM5 6h1v2H5zM3 9h1v2H3zM5 9h1v2H5z"
  }))));
};
export default SvgPlacement;